var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 12.5C20.25 16.804 16.9553 20.3374 12.751 20.7164L12.751 11.4917L14.4697 13.2104C14.7626 13.5033 15.2374 13.5033 15.5303 13.2104C15.8232 12.9175 15.8232 12.4426 15.5303 12.1497L12.5962 9.21554C12.4591 9.03705 12.2435 8.922 12.001 8.922C11.7627 8.922 11.5503 9.03314 11.413 9.20643L8.46966 12.1497C8.17677 12.4426 8.17677 12.9175 8.46966 13.2104C8.76256 13.5033 9.23743 13.5033 9.53033 13.2104L11.251 11.4897L11.251 21.5C11.251 21.9142 11.5868 22.25 12.001 22.25C17.3853 22.25 21.75 17.8852 21.75 12.5C21.75 7.11478 17.3852 2.74999 12 2.74999C6.61478 2.74999 2.24999 7.11478 2.24999 12.5C2.24999 16.3291 4.46244 19.6303 7.66677 21.2254C8.03758 21.41 8.48782 21.259 8.67241 20.8882C8.857 20.5174 8.70604 20.0672 8.33523 19.8826C5.61756 18.5297 3.75 15.7349 3.75 12.5C3.75 7.94321 7.44321 4.25 12 4.25C16.5568 4.25 20.25 7.94321 20.25 12.5Z",
    fill: "#50514A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.249fd9e780e12800fef618f0eab1f7fc.svg";
export { ForwardRef as ReactComponent };